import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ObjectRecordPage } from "@/features/customobjects/ObjectRecordPage";

const search = z.object({
  tab: z.enum(["fields", "relations"]).optional(),
});

export const Route = createFileRoute("/_app/o/$object/$id")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { object, id } = Route.useParams();
  return <ObjectRecordPage objectId={object} recordId={id} search={Route.useSearch()} />;
}
